import React, { FC, Fragment } from 'react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { Category } from 'shared/types/product/Category';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import useClassNames from 'helpers/hooks/useClassNames';
import Markdown from 'components/commercetools-ui/organisms/markdown';
import AccordionBtn from 'components/commercetools-ui/atoms/accordion';
import Button from 'components/commercetools-ui/atoms/button';
import { ArrowRightIcon } from '@heroicons/react/24/solid';
import usePath from 'helpers/hooks/usePath';

export interface Props {
  link: any;
  categoriesNavigator?: Category[];
  onClick: () => void;
  hideHeaderMenu: () => void;
}

const MobileMenuNavButton: FC<Props> = ({ link, categoriesNavigator, onClick, hideHeaderMenu }) => {
  const linkClassNames = useClassNames(['flex justify-between border-b-2 border-white']);

  const { path } = usePath();
  const handleLinkClick = (linkClicked: string) => {
    if (linkClicked.replaceAll('/', '') === path.replaceAll('/', '')) hideHeaderMenu();
  };
  
  return (
    <div key={link?.categoryId} className="cursor-pointer">
      {link?.mega_menu?.submenu_links && link?.mega_menu?.submenu_links?.length > 0 ? (
        <div onClick={onClick} className={linkClassNames}>
          <Typography className="px-48 py-14 text-20 font-semibold text-primary-black">{link?.label}</Typography>
        </div>
      ) : (
        <div className="flex flex-col">
          {link?.title ? (
            <>
              {link?.mega_menu &&
                link?.mega_menu?.map((field: any) => (
                  <Link
                    key={field?.categoryId}
                    link={field?.mega_menu_url?.href}
                    target={field?.mega_menu_url?.href?.includes('https://') ? '_blank' : ''}
                    onClick={() => handleLinkClick(field?.mega_menu_url?.href)}
                  >
                    <Markdown
                      markdown={field?.mega_menu_content}
                      className="border-b-2 border-white px-48 py-14 text-20 font-semibold text-primary-black [&>div>img]:hidden [&>figure]:hidden [&>img]:hidden [&>p>a>img]:hidden [&>p]:text-16 [&>p]:font-medium [&>p]:text-[#090909]"
                    />
                  </Link>
                ))}
              {link?.ctas &&
                link?.ctas.map((cta: any) => (
                  <Link
                    link={cta?.button?.href}
                    key={cta?.button?.title}
                    target={cta?.button?.href?.includes('https://') ? '_blank' : ''}
                    onClick={() => handleLinkClick(cta?.button?.href)}
                  >
                    <Button
                      icon={<ArrowRightIcon className="w-16 text-[#090909]" />}
                      iconPosition="right"
                      className="w-full bg-inherit px-48 py-14 "
                    >
                      <span className="text-16 font-medium text-[#090909] underline underline-offset-4">
                        {cta?.button?.title}
                      </span>
                    </Button>
                  </Link>
                ))}
            </>
          ) : (
            <>
              {link?.mega_menu?.map((section: any, index: number) => (
                <Fragment key={index}>
                  {section?.mega_menu_url?.href === '' ? (
                    <Markdown
                      markdown={section.mega_menu_content}
                      className="border-b-2 border-white px-48 py-14 text-20 font-semibold text-primary-black [&>div>img]:hidden [&>figure]:hidden [&>img]:hidden [&>p>a>img]:hidden [&>p]:text-16 [&>p]:font-medium [&>p]:text-[#090909]"
                    />
                  ) : (
                    <Link
                      link={section?.mega_menu_url?.href}
                      target={section?.mega_menu_url?.href?.includes('https://') ? '_blank' : ''}
                      onClick={() => handleLinkClick(section?.mega_menu_url?.href)}
                    >
                      <Markdown
                        markdown={section.mega_menu_content}
                        className="border-b-2 border-white px-48 py-14 text-20 font-semibold text-primary-black [&>div>img]:hidden [&>figure]:hidden [&>img]:hidden [&>p>a>img]:hidden [&>p]:text-16 [&>p]:font-medium [&>p]:text-[#090909]"
                      />
                    </Link>
                  )}
                </Fragment>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default MobileMenuNavButton;
